import API from "../config/api.js";

export const CustomerService = {
  getAllMembersBySearch(search) {
    return API.get(`api/member/list/se=${search}`);
  },

  getClubMembersBySearch(search) {
    return API.get(`api/club-member/list/se=${search}`);
  },

  getMembersByOfficeRole(search, role) {
    return API.get(`api/office-member/${role}/list/se=${search}`);
  },

  getCustomerList(search , page=1) {
    return API.get(`api/customer/list/se=${search}`, { params: { page: page } });
  },

  getClubMemberInfo(id) {
    return API.get(`api/member/info/${id}`);
  },

  getCustomerInfo(uuid) {
    return API.get(`api/customer/info/${uuid}`);
  },

  update(id, data) {
    return API.post(`api/member/update/${id}`, data);
  },

  create(data) {
    return API.post(`api/customer/create`, data);
  },

  userUpdate(id, data) {
    return API.post(`api/user/member/update/${id}`, data);
  },

  dropMember(uuid) {
    return API.delete(`api/customer/delete/${uuid}`);
  },
  getRegionChairManList() {
    return API.get(`api/region-chairmen/list`);
  },

  getZoneChairManList() {
    return API.get(`api/zone-chairmen/list`);
  },

  customerUpdate(id, data) {
    return API.post(`api/customer/info/update/${id}`, data);
  },

  getCountries() {
    return API.get(`api/customer/country`);
  },

  getStates(country_id) {
    return API.get(`api/customer/state/list/${country_id}`);
  },

  getCustomerCategories() {
    return API.get(`api/customer/category`);
  },

  async getInvoices(uuid, page = 1, perPage = 10, searchQuery = "") {
    // Construct the query parameters
    const params = {
      page,
      perPage,
      search: searchQuery, // Include search query in the parameters
    };

    // Make the API request with dynamic parameters
    return API.get(`api/customer/invoices/list/${uuid}`, { params })
      .then((response) => {
        // Assuming the response data structure has 'invoices' and 'total'
        return {
          invoices: response.data.data, // The 'data' field in the response contains the invoices
          total: response.data.total, // Total number of invoices (for pagination)
        };
      })
      .catch((error) => {
        console.error("Error fetching invoices:", error);
        throw error; // Handle errors if necessary
      });
  },

  createCategory(data) {
    return API.post("/api/customer-category/create", data);
  },

  getAll(){
    return API.get(`/api/customer/all`);
  },

  getAccountSummary(uuid) {
    return API.get(`api/customer/account-summary/${uuid}`);
  },

  getCustomerReceipts(uuid) {
    return API.get(`api/customer/receipts/list/${uuid}`);
  },

  getCustomerReturns(uuid) {
    return API.get(`api/customer-return/list/${uuid}`);
  },

  getCustomerReturnInfo(uuid) {
    return API.get(`api/customer-return/info/${uuid}`);
  },

  createCustomerReturn(data) {
    return API.post(`api/customer-return/create`, data);
  }
};
